import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, TrophyIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FeaturesSection() {
  return <section id="how-it-works" className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-153">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-154">
        <div className="text-center mb-16" data-id="element-155">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-156">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-157">
            Go from overwhelmed to confident in three simple steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-158">
          {/* Step 1: Assess */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-159">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-160">
              1
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-161">
              <ClipboardCheckIcon className="w-8 h-8 text-[#631bb7]" data-id="element-162" />
            </div>
            <h3 className="text-2xl font-bold text-[#111111] mb-4" data-id="element-163">Assess</h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-164">
              Tell us about your devices and habits. In 3 minutes, you'll see
              exactly where you're vulnerable — and what to fix first.
            </p>
          </div>

          {/* Step 2: Guide */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-165">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-166">
              2
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-167">
              <BookOpenIcon className="w-8 h-8 text-[#631bb7]" data-id="element-168" />
            </div>
            <h3 className="text-2xl font-bold text-[#111111] mb-4" data-id="element-169">Learn</h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-170">
              Follow bite-sized lessons that show you what to do and why it
              matters — like having a patient friend walk you through it.
            </p>
          </div>

          {/* Step 3: Empower */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-171">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-172">
              3
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-173">
              <TrophyIcon className="w-8 h-8 text-[#631bb7]" data-id="element-174" />
            </div>
            <h3 className="text-2xl font-bold text-[#111111] mb-4" data-id="element-175">Own It</h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-176">
              Watch your family's Security Score climb as everyone gets safer.
              No more Sunday tech support calls.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-177">
          <Link to="/intro-assessment" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-178">
            Get Started
          </Link>
        </div>
      </div>
    </section>;
}